export default __webpack_public_path__ + "static/media/dra-michelle.1e6ee40e.png";